export default __webpack_public_path__ + "static/media/cookieBox.09000bcd.png";